import { useCallback, useEffect, useState } from "react";

import api from "../../services/api";

// Etapas do quadro de leads, vindas do banco.
//
// Antes eram cinco fixas no código. Cada empresa vende de um jeito — uma
// imobiliária tem "visita agendada", um software tem "em teste" — e não havia
// como mexer sem alterar o sistema.
//
// O cache de módulo evita que cada componente da tela (o quadro, o modal, o
// filtro, os gatilhos) faça a própria chamada: são quatro pedidos idênticos
// numa tela que abre inteira de uma vez.
let cache = null;
const ouvintes = new Set();

const avisar = (etapas) => {
	cache = etapas;
	ouvintes.forEach((fn) => fn(etapas));
};

const useLeadStages = () => {
	const [etapas, setEtapas] = useState(cache || []);
	const [carregando, setCarregando] = useState(!cache);

	const recarregar = useCallback(async () => {
		try {
			const { data } = await api.get("/crm/leads/stages");
			avisar(Array.isArray(data) ? data : []);
		} catch (err) {
			// Sem etapas a tela fica vazia, mas não quebra; quem chamou decide
			// se avisa.
		}
		setCarregando(false);
	}, []);

	useEffect(() => {
		ouvintes.add(setEtapas);

		if (!cache) recarregar();
		else setCarregando(false);

		return () => ouvintes.delete(setEtapas);
	}, [recarregar]);

	// O nome da etapa a partir do que está gravado no lead. Etapa apagada
	// depois: mostra o próprio valor em vez de deixar a célula vazia.
	const rotuloDa = useCallback(
		(slug) => etapas.find((e) => e.slug === slug)?.name || slug,
		[etapas]
	);

	const corDa = useCallback(
		(slug) => etapas.find((e) => e.slug === slug)?.color || "#64748b",
		[etapas]
	);

	return { etapas, carregando, recarregar, rotuloDa, corDa };
};

export default useLeadStages;
